import { create } from 'zustand'

export type DetachedAppLoadStatus = 'idle' | 'loading' | 'ready' | 'error'

export type DetachedAppLoadState = {
  appId: string | null
  status: DetachedAppLoadStatus
}

const idleState: DetachedAppLoadState = { appId: null, status: 'idle' }

export const useDetachedAppLoadStateStore = create<{
  state: DetachedAppLoadState
  setLoadState: (appId: string, status: DetachedAppLoadStatus) => void
  resetLoadState: () => void
}>()(set => ({
  state: idleState,
  setLoadState: (appId, status) => set({ state: { appId, status } }),
  resetLoadState: () => set({ state: idleState })
}))
